function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import tscStyles from '../constants/TscStyles';
import TscThemeName from '../constants/TscThemeName';
import { getClassName } from '../utils/get-class-name';
var Container = styled.div.withConfig({
  displayName: "SelectOption__Container"
})(["width:100%;display:flex;padding:1rem;background-color:", ";box-sizing:border-box;fill:", ";outline:2px solid transparent;outline-offset:-2px;cursor:", ";border-radius:", ";min-width:0;transition:background-color 150ms ease-out;&::-moz-focus-inner{border:0;}&:focus{outline-color:rgba(0,114,207,.5);}&:focus:hover{outline-color:rgba(0,114,207,0);}", ";"], function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.ui.dusk.mediumDark : tscStyles.color.ui.dawn.lightMedium;
}, function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.text.light : tscStyles.color.text.mediumDark;
}, function (props) {
  return props.disabled ? 'default' : 'pointer';
}, function (props) {
  return props.isMenuItem ? '0' : "".concat(tscStyles.border.radius.md, " 0 0 ").concat(tscStyles.border.radius.md);
}, function (props) {
  return !props.disabled && "\n      &:hover {\n         background: ".concat(props.themeName === TscThemeName.dusk ? tscStyles.color.action.secondaryDusk : tscStyles.color.action.secondaryDawn, ";\n         fill: ").concat(props.themeName === TscThemeName.dusk ? tscStyles.color.text.light : tscStyles.color.text.mediumDark, ";\n         text-decoration: none;\n      }\n   ");
});
var TextWrapper = styled.div.withConfig({
  displayName: "SelectOption__TextWrapper"
})(["opacity:", ";overflow:hidden;display:flex;flex-direction:column;"], function (props) {
  return props.disabled ? '.25' : '1';
});
var HeaderTextWrapper = styled.div.withConfig({
  displayName: "SelectOption__HeaderTextWrapper"
})(["display:flex;align-items:center;flex-wrap:wrap;"]);
var PrimaryText = styled.span.withConfig({
  displayName: "SelectOption__PrimaryText"
})(["font-weight:", ";font-size:", ";display:inline-block;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;padding:2px 0;margin-right:0.5rem;color:", ";"], tscStyles.font.weight.semibold, tscStyles.font.size.regular, function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.text.light : tscStyles.color.text.mediumDark;
});
var BadgeText = styled.span.withConfig({
  displayName: "SelectOption__BadgeText"
})(["border-radius:10rem;background-color:", ";color:", ";padding:2px 0.5rem;font-weight:", ";font-size:", ";overflow:hidden;text-overflow:ellipsis;white-space:nowrap;"], tscStyles.color.message.caution, tscStyles.color.text.dark, tscStyles.font.weight.semibold, tscStyles.font.size.regular);
var SecondaryText = styled.span.withConfig({
  displayName: "SelectOption__SecondaryText"
})(["font-weight:", ";font-size:", ";display:inline-block;overflow:hidden;text-overflow:ellipsis;line-height:1.25rem;max-height:3.75rem;color:", ";"], tscStyles.font.weight.regular, tscStyles.font.size.regular, function (props) {
  return props.themeName === TscThemeName.dusk ? tscStyles.color.text.lightMedium : tscStyles.color.text.medium;
});
var GlyphStyled = styled.span.withConfig({
  displayName: "SelectOption__GlyphStyled"
})(["pointer-events:none;display:inline-block;vertical-align:middle;margin:0.25rem 0.5rem 0 0;opacity:", ";svg{display:block;}img{display:block;}"], function (props) {
  return props.disabled ? '.25' : '1';
});

var SelectOption = function SelectOption(_ref) {
  var badgeText = _ref.badgeText,
      className = _ref.className,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      glyph = _ref.glyph,
      _ref$isMenuItem = _ref.isMenuItem,
      isMenuItem = _ref$isMenuItem === void 0 ? true : _ref$isMenuItem,
      onClick = _ref.onClick,
      _ref$subtext = _ref.subtext,
      subtext = _ref$subtext === void 0 ? '' : _ref$subtext,
      _ref$text = _ref.text,
      text = _ref$text === void 0 ? '' : _ref$text,
      _ref$themeName = _ref.themeName,
      themeName = _ref$themeName === void 0 ? TscThemeName.dawn : _ref$themeName,
      value = _ref.value;

  var handleClick = function handleClick(e) {
    if (disabled) {
      e.stopPropagation();
      e.preventDefault();
    } else {
      onClick && onClick(e, value);
    }
  };

  var controlProps = {
    themeName: themeName,
    disabled: disabled,
    isMenuItem: isMenuItem,
    // we pin this onto the 'container' props so consumer can tap into the 'value' prop as-if it were a standard select-option
    value: value
  };
  return _jsxs(Container, _objectSpread(_objectSpread({
    className: getClassName(className, null, 'option-wrapper')
  }, controlProps), {}, {
    onClick: function onClick(e) {
      return isMenuItem && handleClick(e);
    },
    tabIndex: isMenuItem ? -1 : undefined,
    role: isMenuItem ? 'option' : undefined,
    disabled: disabled,
    children: [glyph && _jsx(GlyphStyled, _objectSpread(_objectSpread({
      className: getClassName(className, 'glyph-styled')
    }, controlProps), {}, {
      children: glyph
    })), _jsxs(TextWrapper, _objectSpread(_objectSpread({
      className: getClassName(className, 'text-wrapper')
    }, controlProps), {}, {
      children: [_jsxs(HeaderTextWrapper, {
        className: getClassName(className, 'header-text-wrapper'),
        children: [_jsx(PrimaryText, _objectSpread(_objectSpread({
          className: getClassName(className, 'primary-text')
        }, controlProps), {}, {
          children: text
        })), !!badgeText && _jsx(BadgeText, {
          className: getClassName(className, 'badge-text'),
          children: badgeText
        })]
      }), _jsx(SecondaryText, _objectSpread(_objectSpread({
        className: getClassName(className, 'secondary-text')
      }, controlProps), {}, {
        children: subtext
      }))]
    }))]
  }));
};

var SelectOptionTest = {
  Container: Container
};
export { SelectOption, SelectOptionTest };
export default SelectOption;